import { Component, Input, OnInit } from '@angular/core';
import { DataTable, SortEvent } from '@pascalhonegger/ng-datatable';

@Component({
    selector: 'app-table-sorter',
    template: `
        <a style="cursor: pointer" (click)="sort()" class="text-nowrap">
            <ng-content></ng-content>
            <span *ngIf="isSortedByMeAsc" class="fas fa-caret-up ml-1" aria-hidden="true"></span>
            <span *ngIf="isSortedByMeDesc" class="fas fa-caret-down ml-1" aria-hidden="true"></span>
            <span *ngIf="!isSortedByMeAsc && !isSortedByMeDesc" class="ml-1 fa fa-sort" aria-hidden="true"></span>
        </a>`
})
export class TableSorterComponent implements OnInit {
    // tslint:disable-next-line: no-input-rename
    @Input('by') public sortBy!: string;

    public isSortedByMeAsc: boolean = false;
    public isSortedByMeDesc: boolean = false;

    public constructor(private mfTable: DataTable) {
    }

    public ngOnInit(): void {
        this.mfTable.onSortChange.subscribe((event: SortEvent) => {
            // tslint:disable:triple-equals
            this.isSortedByMeAsc = (event.sortBy == this.sortBy && event.sortOrder == 'asc');
            this.isSortedByMeDesc = (event.sortBy == this.sortBy && event.sortOrder == 'desc');
            // tslint:enable:triple-equals
        });
    }

    public sort(): void {
        if (this.isSortedByMeAsc) {
            this.mfTable.setSort(this.sortBy, 'desc');
        } else {
            this.mfTable.setSort(this.sortBy, 'asc');
        }
    }
}
